import {Exclude, Expose} from "class-transformer";

@Exclude()
export class CredentialsApiModel {
  @Expose() public username: string;
  @Expose() public password: string;
  @Expose() public remember: boolean;
}
